<div class="facilities-list-container container-vertical">
  @for (facility of facilities$ | async; track facility) {
  <div class="facility-box">
    <div class="container-horizontal">
      <div class="facility-details">
        <div class="facility-header">
          <h3>{{ facility.name }}</h3>
        </div>
        <div class="facility-description">
          <span>{{ facility.description }}</span>
        </div>
        <div class="container-horizontal facility-info">
          <app-property-block icon="build" title="Asset type" [content]="facility.assetType"> </app-property-block>
          <app-property-block icon="domain" title="Facility type" [content]="facility.facilityType"> </app-property-block>
          <!-- TODO when facility.assignees ready -->
          <app-property-block icon="group" title="Assignees" content="People"> </app-property-block>
        </div>
      </div>
      <div class="facility-edit">
        <div>
          <div class="info-item">
            <button class="iconf-btn-blank minw100" (click)="editFacility(facility.id)">
              <mat-icon>edit</mat-icon>
              edit
            </button>
          </div>
          <div class="info-item">
            <button class="iconf-btn-blank minw100" (click)="deleteFacility(facility.id)">
              <mat-icon>delete</mat-icon>
              delete
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
  }
</div>
<div class="facilities-list-add-new">
  <button class="iconf-btn-blank minw150" (click)="addFacility()">
    <mat-icon>add_circle</mat-icon>
    add facility
  </button>
</div>
<div class="actions">
  <button class="iconf-btn-filled minw150 minh40" (click)="navigateToProjectAndClose()">
    {{ (facilities$ | async)?.length > 0 ? 'done' : 'add later' }}
  </button>
</div>
